import { BiSearch } from "react-icons/bi";
import styled from "styled-components";
import { SearchIcon } from "./icons";
import { useState } from "react";

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const SearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  background-color: white;
  width: 100%;
  gap: 2px;
  &:focus-within {
    outline: 2px solid #0c8ce9;
  }
`;

const IconWrapper = styled.div`
  color: #64748b;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  width: 100%;
  font-size: 16px;
  color: #111827;
  &::placeholder {
    color: #737373;
  }
`;

type Props = {
  search: string;
  setSearch: (val: string) => void;
  onSubmit?: () => void;
};

export function SearchBar({ search, setSearch, onSubmit }: Props) {
  const [isOnFocus, setIsOnFocus] = useState(false);

  return (
    <SearchContainer>
      <SearchInputWrapper>
        {!isOnFocus && (
          <IconWrapper>
            <SearchIcon />
          </IconWrapper>
        )}
        <SearchInput
          type="text"
          placeholder="고객명 또는 주소로 검색"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSubmit?.()}
          onFocus={(e) => setIsOnFocus(true)}
          onBlur={(e) => setIsOnFocus(false)}
        />
      </SearchInputWrapper>
    </SearchContainer>
  );
}
